import { MonitorCustomerData } from '@Src/_basic/object/MonitorType';
import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  row: MonitorCustomerData;
}
export default function TotalCarColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.orderCount}</Typography>;
}
